import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate, useParams } from "react-router";
import { Box, Typography, useTheme } from "@mui/material";
import HeaderBar from "../Shared/HeaderBar/HeaderBar"
import SubHeaderBar from "./SubHeader/SubHeaderBar.js";
import PageContainer from './Containers/PageContainer/PageContainer.js';
import ScheduleContainer from "./Containers/ScheduleContainer/ScheduleContainer.js";
import NavigationBar from "../Shared/NavigationBar/NavigationBar"
import { fetchChannelData, fetchSchema } from "../../utilities/apiRequests.js";

export default function NewChannelPage(){

    let [pageMode, setPageMode] = useState('read')
    let [stateObject, setStateObject] = useState(null)

    const { getAccessTokenSilently } = useAuth0();
    let navigate = useNavigate()
    let theme = useTheme()


    const { channelID } = useParams();



    // fetch schema and channelData from api
    let [apiResponses, setApiResponses] = useState({schema:null, channelData:null})
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let fetchedChannelData = ""
        let fetchedSchema = ""

        async function fetchApiResponses()  {
            await getAccessTokenSilently({ authorizationParams: { scope: "write:channels" } })
                .then(async (accessToken) => fetchSchema(accessToken))
                .then((schemaResponse) => (fetchedSchema=schemaResponse))
                .catch((error) => {
                    console.error("Error fetching schema:", error);
                    navigate("/stationspage");
                    setError(true);
                })

            await getAccessTokenSilently({ authorizationParams: { scope: "read:channels" } })
                .then(async (accessToken) => fetchChannelData(channelID, accessToken))
                .then((channelDataResponse) => (fetchedChannelData=channelDataResponse))
                .catch((error) => {
                    console.error("Error fetching channel data:", error);
                    navigate("/stationspage");
                    setError(true);
                })
            
            setApiResponses({schema:fetchedSchema, channelData:fetchedChannelData})
            setLoading(false)
        };

        fetchApiResponses()
    }, [getAccessTokenSilently, navigate, channelID]);


    let schema = apiResponses.schema
    let channelData = apiResponses.channelData

    if (loading) {
        return (
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    if (error) return;

    //split contacts from rows here 
    let contactsList = channelData.contacts
    let {contacts, ...stationFields } = channelData
    delete stationFields.channel_id //remove uneditable primary key

    let stationAttributes = Object.keys(schema.properties).sort()

    let state = {}

    for(let i = 0; i < stationAttributes.length; i++){
        let stationAttribute = stationAttributes[i]
        let value = stationFields[stationAttribute]
        if (value === undefined) value = ""
        state[stationAttribute] = {
            oldValue: value,
            currentValue: "",
            currentInput: "",
            lockState: true,
            updatedState: false,
            focusState: false,
        }
    }

    if (stateObject === null) setStateObject({...state})


    const handleRevertAllChangesClick = (event) => {
        event.preventDefault()
        setStateObject({...state})
        console.log("handleRevertAllChangesClick()")
    }


    const handleSaveAllChangesClick = (event) => {
        event.preventDefault()
        console.log("handleSaveAllChangesClick()")
    }


    function setStateObjectEntryHelper(stationAttribute, updatedEntry){
        stateObject[stationAttribute] = updatedEntry
        setStateObject({...stateObject})
    }


    function setStateObjectEntryFieldHelper(stationAttribute, field, updatedValue){
        let updatedEntry = stateObject[stationAttribute]
        updatedEntry[field] = updatedValue
        setStateObject({...stateObject, stationAttribute: updatedEntry})
    }

    return (
        <>
            <HeaderBar></HeaderBar>
                <Box backgroundColor={theme.palette.NewChannelPage.background} width={'100%'}>
                    <SubHeaderBar pageMode={pageMode} setPageMode={setPageMode} channelData={channelData} handleSaveAllChangesClick={handleSaveAllChangesClick} handleRevertAllChangesClick={handleRevertAllChangesClick}/>


                    {(pageMode === 'read' || pageMode === 'edit') && (
                        <PageContainer pageMode={pageMode} stationAttributes={stationAttributes} contactsList={contactsList}
                                        stateObject={stateObject} setStateObjectEntryHelper={setStateObjectEntryHelper}
                                        setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                                        />

                    )}

                    {(pageMode === 'schedule') && (
                        <ScheduleContainer pageMode={pageMode} channelData={channelData}></ScheduleContainer>
                    )}
                </Box>
            <NavigationBar></NavigationBar>
        </>
    )
}
